module.exports = __webpack_public_path__ + "static/media/alpha_2.fe8df457.png";